import $ from 'jquery';
import 'jquery-validation';
import 'jquery-validation-unobtrusive';

window.$ = window.jQuery = $;